import * as React from 'react';
import {Typography, WithStyles, withStyles, IconButton, Grid, } from '@material-ui/core';
import {EcoRepeat, IEcoAgreement, IEcoSplit} from "@app-types/websocket/economy.types";
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import { ecoContainerStyle } from './Container.style';
import ImgAvatar from '@components/common/avatar/ImgAvatar';
import {EditOutlined} from "@material-ui/icons";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import ChatIcon from '@material-ui/icons/QuestionAnswerOutlined';
import RepeatIcon from '@material-ui/icons/RepeatRounded';
import { getWeekNum } from '@helpers/DateHelper';
import { styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ecoContainerStyle>
{
    agreement: IEcoAgreement;
    family: IFamilyMember[];
    userId:number;
    currency:string;
    editAgreement: (purchase:IEcoAgreement) => void;
    completeAgreement: (purchase:IEcoAgreement) => void;
    seenAgreement: (id:number) => void;
    scrollTime:number;
    tooltip?:boolean;
    hideTooltip: () => void;
}

interface IState
{
    seenCalled: boolean;
    hideTooltip: boolean;
}

class ListItemApprovedAgreement extends React.Component<IProps,IState> {

    private myRef: HTMLDivElement | null = null;

    constructor(props: IProps) {
        super(props);
    
        this.state = {
            seenCalled: false,
            hideTooltip: false,
        };
    
    }

    public componentDidMount() {
        if (this.state.seenCalled === false 
          && this.props.agreement.seenBy.indexOf(this.props.userId) === -1) {
          if (this.isInViewport()) {
            this.setState({seenCalled:true});
            this.props.seenAgreement(this.props.agreement.id);
          }
        }
    }

    public componentDidUpdate(prevProps: Readonly<IProps>): void {
        if (this.state.seenCalled === false 
            && prevProps.scrollTime !== this.props.scrollTime
            && this.props.agreement.seenBy.indexOf(this.props.userId) === -1) 
        {
            if (this.isInViewport()) {
              this.setState({seenCalled:true});
              this.props.seenAgreement(this.props.agreement.id);
            }
          }
    }

    public render() { 
        const {userId, classes, agreement} = this.props;


        return(
            <div key={agreement.id} className={classes.cardContent} 
                style={(!agreement.seenBy.includes(userId))
                    ?{ boxShadow: `0px 0px 20px ${styleColors.redShadow23}`, backgroundColor: styleColors.brightCoralTint12, }
                    :{ boxShadow: '0px 0px 20px rgb(255 0 0 / 0%)', backgroundColor: styleColors.transparent, }}
                ref={(el) => this.myRef = el}>
                <div className={classes.cardContentListItem} onClick={() => this.props.editAgreement(agreement)} style={{cursor:'pointer'}}>
                    <div className={classes.itemTopRow}>
                        {(agreement.children.length > 0) &&
                        <div style={{display: 'flex', flexDirection: 'row', gap: '4px'}}>
                            {this.renderAgreementResponsibles(agreement.children)}
                        </div>}
                        <div className={classes.parentWithTraillingText}>
                            <Typography className={[classes.body1, classes.traillingTittle].join(' ')}>
                                {
                                    agreement.repeat === EcoRepeat.ONCE
                                        ? agreement.title
                                    : agreement.repeat === EcoRepeat.WEEKLY?
                                        `${agreement.title} (${tn.lang.getWeekName(getWeekNum(new Date(agreement.forDate)))})`
                                    : agreement.repeat === EcoRepeat.MONTHLY?
                                        `${agreement.title} (${tn.lang.getMonthName((new Date(agreement.forDate)).getMonth())})`
                                    : agreement.repeat === EcoRepeat.QUARTERLY?
                                        `${agreement.title} (${tn.lang.getQuarterName((new Date(agreement.forDate)))})`
                                    : agreement.repeat === EcoRepeat.TERM?
                                        `${agreement.title} (${tn.lang.getTermName((new Date(agreement.forDate)))})`
                                    :`${agreement.title} (${(new Date(agreement.forDate)).getFullYear()})`
                                }
                            </Typography>
                        </div>
                        <Typography className={classes.body1}>
                            {agreement.amount ? tn.formatNumber(agreement.amount, this.props.currency) : ''}
                        </Typography>                                    
                    </div>
                    <div className={classes.itemBottomRow}>
                        <div style={{display:'flex', flexDirection: 'row', gap:'4px'}}>
                        {this.renderAgreementSplit(agreement.split)}
                        {(!!agreement.description && agreement.description.length > 0) 
                            && <EditOutlined style={{fill:styleColors.warmGrey, fontSize:'12px', transform: 'translate(0px, 1px)'}} />}
                        {(!!agreement.images && agreement.images.length > 0) 
                            && <ImageOutlinedIcon style={{fill:styleColors.warmGrey, fontSize:'12px', transform: 'translate(0px, 1px)'}}  />}
                        {(agreement.chatId !== undefined) 
                            && <ChatIcon style={{fill:styleColors.warmGrey, fontSize:'12px', transform: 'translate(0px, 1px)'}}  />}
                        {(agreement.repeat !== EcoRepeat.ONCE) 
                            && <RepeatIcon style={{fill:styleColors.warmGrey, fontSize:'12px', transform: 'translate(0px, 1px)'}}  />}
                        </div>
                    </div>
                </div>
                <div style={{display: 'flex', alignItems: 'center', position:'relative'}}>
                    <IconButton onClick={() => this.props.completeAgreement(agreement)}>
                        <CheckCircleIcon htmlColor={styleColors.greyMedium1} />
                    </IconButton>
                    {(!this.state.hideTooltip && this.props.tooltip)
                        &&<div className={classes.tooltip} onClick={() => {
                            this.setState({hideTooltip:true});
                            this.props.hideTooltip();
                        }}>
                            {tn.lang.agreementTooltipHelp}
                        </div>}
                </div>
            </div>
        );
    }

    private isInViewport(offset = 0) {
        if (!this.myRef) { return false; }
        const rect = this.myRef.getBoundingClientRect();
        const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        const viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);
    
        if (!(rect.left >= 0 && rect.right <= viewWidth)) { return false; }
        if (!(rect.top >= 0 && (rect.top + 50) <= viewHeight)) { return false; } // if 50 pixels has been seen thats enough
    
        return true;
    }


    private getAvatar(member: IFamilyMember, size:number = 30) {
        const image = member.avatar;
        const name = member.firstName;
        const color = member.color;
        const style:any = {width:size, height:size};

        return <ImgAvatar key={member.id} color={color} imgName={image} style={style} altText={name} 
            imgUrl={member.imageAvatar?member.avatarURL:undefined} />;
    }

    private renderAgreementSplit = (splitAgreement: IEcoSplit[]) => {
        const { classes } = this.props;
        const fullResponsibility = splitAgreement.find(sa => sa.percentage === 100);
        if(fullResponsibility) {
            const account = this.props.family.find((member) => member.id === fullResponsibility.accountId);
            if(!account) return ;
            return (
                <Grid key={account.id} className={classes.splitAgreementItem}>
                    <Typography color="textSecondary" className={classes.body2}>
                        <span>{tn.lang.agreementPaysAll(account.firstName)}</span>
                    </Typography>
                </Grid>
            );
        }
        const myShare = splitAgreement.find(sa => sa.accountId === this.props.userId);
        if(myShare) {
            return (
                <Grid key={this.props.userId} className={classes.splitAgreementItem}>
                    <Typography color="textSecondary" className={classes.body2} >
                        <span>{tn.lang.agreementMyPart(myShare.percentage)}</span>
                    </Typography>
                </Grid>
            );
        }
        return splitAgreement.map(
            (split) => {
                const account = this.props.family.find((member) => member.id === split.accountId);
                if(!account) return null;
                return (
                    <Grid key={account.id} className={classes.splitAgreementItem}>
                        {this.getAvatar(account, 14)}
                        <Typography color="textSecondary" className={classes.body2}>
                            {split.percentage}%
                        </Typography>
                    </Grid>
                );
            }
        );
    }

    private renderAgreementResponsibles = (responsibles: number[]) => {
        return responsibles.map(
            (responsible) => {
                const account = this.props.family.find((member) => member.id === responsible);
                if(!account) return null;
                return this.getAvatar(account, 14);
            }
        );
    }
}

export default withStyles(ecoContainerStyle)(ListItemApprovedAgreement);



// WEBPACK FOOTER //
// ./src/components/economy/ListItemApprovedAgreement.tsx